import React, { memo } from 'react';
import { IconProps } from '.';

type GoogleIconProps = {} & IconProps;

export const GoogleIcon: React.FC<GoogleIconProps> = memo(
  ({ height = 24, width = 24 }) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 26 26"
      >
        <path
          fill="#4285F4"
          fillRule="evenodd"
          d="M25.48 13.295c0-.921-.083-1.808-.237-2.659H13v5.029h6.996a5.98 5.98 0 01-2.594 3.923v3.262h4.201c2.458-2.263 3.876-5.596 3.876-9.555z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#34A853"
          fillRule="evenodd"
          d="M13 26c3.51 0 6.452-1.165 8.603-3.15l-4.201-3.262c-1.164.78-2.654 1.24-4.403 1.24-3.385 0-6.251-2.286-7.273-5.358H1.383v3.368a12.995 12.995 0 0011.616 7.161z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#FBBC05"
          fillRule="evenodd"
          d="M5.726 15.47A7.814 7.814 0 015.318 13c0-.857.148-1.69.408-2.47V7.162H1.383A12.995 12.995 0 000 13c0 2.098.502 4.083 1.383 5.838l4.343-3.368z"
          clipRule="evenodd"
        ></path>
        <path
          fill="#EA4335"
          fillRule="evenodd"
          d="M13 5.17c1.908 0 3.622.656 4.969 1.945l3.728-3.729C19.447 1.288 16.503 0 13 0A12.995 12.995 0 001.382 7.162l4.343 3.368c1.022-3.073 3.888-5.36 7.273-5.36z"
          clipRule="evenodd"
        ></path>
      </svg>
    );
  }
);
